"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyNonIntrusiveNotification = void 0;

const faExclamationCircle_1 = require("@fortawesome/pro-regular-svg-icons/faExclamationCircle");

const faInfoCircle_1 = require("@fortawesome/pro-regular-svg-icons/faInfoCircle");

const faQuestionCircle_1 = require("@fortawesome/pro-regular-svg-icons/faQuestionCircle");

const react_fontawesome_1 = require("@fortawesome/react-fontawesome");

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const JUSTIFICATION_MAP = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
};
const BACKGROUND_COLOR_MAP = {
  error: "#FFEAEA",
  warning: "#FFF8E5",
  info: "#F3F3F3",
  tip: "#EAF4FD"
};
const StyledNotificationContainer = (0, material_1.styled)("div", {
  shouldForwardProp: prop => prop !== "justification" && prop !== "notificationType"
})(({
  justification,
  notificationType
}) => ({
  padding: "14px 24px",
  fontSize: 12,
  color: "#666666",
  display: "flex",
  alignItems: "center",
  justifyContent: JUSTIFICATION_MAP[justification],
  backgroundColor: BACKGROUND_COLOR_MAP[notificationType]
}));
const NOTIFICATION_COLOR_MAP = {
  error: "#FF3333",
  warning: "#FF9900",
  info: "#666666",
  tip: "#0066CC"
};
const StyledNotificationIcon = (0, material_1.styled)(react_fontawesome_1.FontAwesomeIcon, {
  shouldForwardProp: prop => prop !== "notificationType"
})(({
  notificationType
}) => ({
  fontSize: "17px",
  marginRight: "10px",
  color: NOTIFICATION_COLOR_MAP[notificationType]
}));

const getIcon = notificationType => {
  switch (notificationType) {
    case "tip":
      return faInfoCircle_1.faInfoCircle;

    case "info":
      return faQuestionCircle_1.faQuestionCircle;

    default:
      return faExclamationCircle_1.faExclamationCircle;
  }
};

const SskyNonIntrusiveNotification = props => {
  const icon = getIcon(props.notificationType);
  return react_1.default.createElement(StyledNotificationContainer, {
    className: props.className,
    "data-testid": props.dataTestId,
    justification: props.justification,
    notificationType: props.notificationType
  }, react_1.default.createElement(StyledNotificationIcon, {
    icon: icon,
    notificationType: props.notificationType
  }), typeof props.text === "string" ? react_1.default.createElement("span", null, props.text) : props.text);
};

exports.SskyNonIntrusiveNotification = SskyNonIntrusiveNotification;
SskyNonIntrusiveNotification.defaultProps = {
  justification: "left"
};
exports.default = react_1.default.memo(SskyNonIntrusiveNotification);